// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_POST = "p\u0159id\u00e1n\u00ed diskuze";
export const ACTION_TO_SEND_HEART = "odesl\u00e1n\u00ed srd\u00ed\u010dka";
